import { createFileRoute, notFound } from "@tanstack/react-router";
// Direct files, not the feature's index: this route's loader ships in every
// page's first download.
import { WomenApiError } from "../../../features/women/api/women.api";
import { organiserQueryOptions } from "../../../features/women/api/women-query";
import { useOrganiser } from "../../../features/women/hooks/use-women-trips";
import { OrganiserPage } from "../../../features/women/pages/organiser-page";

/**
 * `/{lang}/organiser/{slug}`: one women-only trip organiser and her trips.
 * Loaded on the server; an unknown organiser is a real 404, not an empty page.
 */
export const Route = createFileRoute("/$lang/_layout/organiser/$slug")({
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.ensureQueryData(organiserQueryOptions(params.slug, params.lang));
    } catch (err) {
      if (err instanceof WomenApiError && (err.status === 404 || err.status === 400 || err.status === 422)) {
        throw notFound();
      }
      throw err;
    }
  },
  component: OrganiserRoute,
});

function OrganiserRoute() {
  const { lang, slug } = Route.useParams();
  const { data } = useOrganiser(slug, lang);
  return <OrganiserPage organiser={data} lang={lang} />;
}
